module.exports = __webpack_public_path__ + "static/media/addNote.88dceb2a.gif";